<div class="container">
    <div class="wrapper">
        <div class="wrapperTop">
            <h3>¿Desea agregar un comentario?</h3>
            <input [(ngModel)]="comentarioSolucion" type="text">
        </div>
        <div class="wrapperBottom">
            <button nbButton size="small" class="buttontz reporteBTN" (click)="close()">Cancelar</button>
            <button nbButton size="small" class="buttontz reporteBTN" (click)="close('Solucion')"
                [disabled]="!comentarioSolucion">Solucionar</button>
        </div>
    </div>
</div>